import { Injectable } from '@angular/core';
import * as fromActions from '@main/smart-banner/data-access';
import { SmartBannerApiService } from '@main/smart-banner/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, Observable, of, switchMap } from 'rxjs';

@Injectable()
export class SmartBannerEffects {
  loadSmartBanner$: Observable<fromActions.LoadSmartBannerSuccess | fromActions.LoadSmartBannerFail> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromActions.LOAD_SMART_BANNER),
        map((action: fromActions.LoadSmartBanner) => action.payload),
        switchMap((cityCode) => {
          return this.smartBannerApiService.getSmartBannerData(cityCode).pipe(
            map((res) => new fromActions.LoadSmartBannerSuccess(res)),
            catchError((error: unknown) => of(new fromActions.LoadSmartBannerFail(error))),
          );
        }),
      ),
  );

  constructor(
    private actions$: Actions,
    private smartBannerApiService: SmartBannerApiService,
  ) {}
}
